import apiCalendarPlan from '@/api/calendar-plan'

const state = {
  data: [],
  total: null,
  isLoading: false,
  error: null,
}

export const mutationTypes = {
  getCalendarPlanStart:
    '[calendar plan kinds sport] Get calendar plan kinds sport start',
  getCalendarPlanSuccess:
    '[calendar plan kinds sport] Get calendar plan kinds sport success',
  getCalendarPlanFailure:
    '[calendar plan kinds sport] Get calendar plan kinds sport failure',
}

export const actionTypes = {
  getCalendarPlan: '[calendar plan kinds sport] Get calendar plan kinds sport',
}

const mutations = {
  [mutationTypes.getCalendarPlanStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getCalendarPlanSuccess](state, payload) {
    state.data = payload.list
    state.total = payload.total
    state.isLoading = false
  },

  [mutationTypes.getCalendarPlanFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.getCalendarPlan](context, {id, params}) {
    context.commit(mutationTypes.getCalendarPlanStart)
    return new Promise((resolve) => {
      apiCalendarPlan
        .getCalendarPlansKindsSport(id, params)
        .then((response) => {
          context.commit(mutationTypes.getCalendarPlanSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getCalendarPlanFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
